import {
	default as EChartsReact,
	default as ReactECharts,
} from "echarts-for-react";
import React, { Component } from "react";
import {
	ENROLLMENT_DISTRIBUTION,
	studentIndividualGradeCount,
} from "../../../api/types";
// interface data {
// 	value: number;
// 	name: string;
// }
interface AppProp {
	value: Array<studentIndividualGradeCount>;
	onDownload: (urls: [string, string]) => void;
}
const displayStudentYearLevel = [
	"Year Level 1",
	"Year Level 2",
	"Year Level 3",
	"Year Level 4",
	"Year Level 5",
	"Year Level 6",
	"Year Level 7",
	"Year Level 8",
	"Year Level 9",
	"Year Level 10",
];

export class StudentYearLevelDistribution extends Component<AppProp, {}> {
	private echartsRef: React.RefObject<EChartsReact>;

	private onDownload: (urls: [string, string]) => void;

	constructor(props: AppProp) {
		super(props);
		this.echartsRef = React.createRef();
		this.onDownload = props.onDownload;
		this.state = { imgUrl: "" };
	}

	componentDidUpdate(
		_prevProps: Readonly<AppProp>,
		prevState: { imgUrl: string },
	): void {
		// @ts-ignore
		const base64: string = this.echartsRef.current
			.getEchartsInstance()
			.getDataURL();
		if (prevState.imgUrl !== base64) {
			this.setState({ imgUrl: base64 });
			this.onDownload([ENROLLMENT_DISTRIBUTION, base64]);
		}
	}

	getData(name: number, dict: Array<studentIndividualGradeCount>): number {
		let output: number = 0;
		for (const item of dict) {
			if (item.YearLevel === name) {
				output = +item.StudentCount;
				break;
			}
		}

		return output;
	}

	getOption(studentsGradeCount: Array<studentIndividualGradeCount>): Object {
		return {
			title: {
				text: "Student Year Level Distribution",
				left: "center",
			},
			tooltip: {
				trigger: "item",
				formatter: "{a} <br/>{b}: {c} ({d}%)",
			},
			series: [
				{
					name: "Year Level: ",
					type: "pie",
					radius: "70%",
					// data: this.getData(activity),
					data: [
						{
							value:
								this.getData(1, studentsGradeCount) === 0
									? null
									: this.getData(1, studentsGradeCount),
							name: displayStudentYearLevel[0],
							itemStyle: { color: "#DD4E42" },
						},
						{
							value:
								this.getData(2, studentsGradeCount) === 0
									? null
									: this.getData(2, studentsGradeCount),
							name: displayStudentYearLevel[1],
							itemStyle: { color: "#F18458" },
						},
						{
							value:
								this.getData(3, studentsGradeCount) === 0
									? null
									: this.getData(3, studentsGradeCount),
							name: displayStudentYearLevel[2],
							itemStyle: { color: "#F1D25B" },
						},
						{
							value:
								this.getData(4, studentsGradeCount) === 0
									? null
									: this.getData(4, studentsGradeCount),
							name: displayStudentYearLevel[3],
							itemStyle: { color: "#D2C39F" },
						},
						{
							value:
								this.getData(5, studentsGradeCount) === 0
									? null
									: this.getData(5, studentsGradeCount),
							name: displayStudentYearLevel[4],
							itemStyle: { color: "#8FC181" },
						},
						{
							value:
								this.getData(6, studentsGradeCount) === 0
									? null
									: this.getData(6, studentsGradeCount),
							name: displayStudentYearLevel[5],
							itemStyle: { color: "#73DCCD" },
						},
						{
							value:
								this.getData(7, studentsGradeCount) === 0
									? null
									: this.getData(7, studentsGradeCount),
							name: displayStudentYearLevel[6],
							itemStyle: { color: "#CEE7F5" },
						},
						{
							value:
								this.getData(8, studentsGradeCount) === 0
									? null
									: this.getData(8, studentsGradeCount),
							name: displayStudentYearLevel[7],
							itemStyle: { color: "#6272D1" },
						},
						{
							value:
								this.getData(9, studentsGradeCount) === 0
									? null
									: this.getData(9, studentsGradeCount),
							name: displayStudentYearLevel[8],
							itemStyle: { color: "#8B5AA3" },
						},
						{
							value:
								this.getData(10, studentsGradeCount) === 0
									? null
									: this.getData(10, studentsGradeCount),
							name: displayStudentYearLevel[9],
							itemStyle: { color: "#FCC2D7" },
						},
					],
					emphasis: {
						itemStyle: {
							shadowBlur: 10,
							shadowOffsetX: 0,
							shadowColor: "rgba(0, 0, 0, 0.5)",
						},
					},
				},
			],
		};
	}

	render(): JSX.Element {
		return (
			<ReactECharts
				ref={this.echartsRef}
				option={this.getOption(this.props.value)}
				// style={{height: '250px', width: '500px'}}
			/>
		);
	}
}
